export default {
  strict: true,
  namespaced: true,
  state: {
    show: false,
    noteId: null,
    notes: '',
    noteStatus: 'new',
    driverId: null,
    rsvpId: null,
    isPackage: false,
    label: '',
    action: '',
    actionType: '',
    actionData: '{}',
    forComplete: false,
    fromRsvpDetails: false,
    admins: [],
    isProv: false,
    isLyftService: false
  },
  mutations: {
    show (state, value) {
      state.show = true

      state.noteId = null
      if (value.noteId) {
        state.noteId = value.noteId
      }

      state.notes = ''
      if (value.notes) {
        state.notes = value.notes
      }

      state.noteStatus = 'new'
      if (value.noteStatus) {
        state.noteStatus = value.noteStatus
      }

      state.driverId = null
      if (value.driverId) {
        state.driverId = value.driverId
      }

      state.rsvpId = null
      if (value.rsvpId) {
        state.rsvpId = value.rsvpId
      }

      state.isPackage = false
      if (value.isPackage) {
        state.isPackage = value.isPackage
      }

      state.action = ''
      if (value.action) {
        state.action = value.action
      }

      state.actionType = ''
      if (value.actionType) {
        state.actionType = value.actionType
      }

      state.actionData = '{}'
      if (value.actionData) {
        state.actionData = value.actionData
      }

      state.forComplete = false
      if (value.forComplete) {
        state.forComplete = value.forComplete
      }

      state.fromRsvpDetails = false
      if (value.fromRsvpDetails) {
        state.fromRsvpDetails = value.fromRsvpDetails
      }

      state.label = ''
      if (value.label) {
        state.label = value.label
      }
      
      state.isProv = false
      if (value.isProv) {
        state.isProv = value.isProv
      }
    },
    hide (state) {
      state.show = false
      state.noteId = null
      state.notes = ''
      state.noteStatus = 'new'
      state.driverId = null
      state.rsvpId = null
      state.isPackage = false
      state.actionType = ''
      state.actionData = '{}'
      state.forComplete = false
      state.fromRsvpDetails = false
      state.isLyftService = false
    },
    setNotes (state, value) { state.notes = value },
    setNoteStatus (state, value) { state.noteStatus = value },
    setAdmins (state, value) { state.admins = value },
    setNotesModalData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    }
  },
  sharedMutations: [
    'reservationNotes/setAdmins'
  ]
}



// WEBPACK FOOTER //
// ./src/store/reservation-notes-modal.js